import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import "./design/tokens.css";

const root = document.getElementById("root");
if (root === null) throw new Error("Application root is missing.");
const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 2, staleTime: 30_000 } } });
const reactRoot = createRoot(root);

void import("./app/router").then(({ router }) => {
  reactRoot.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}><RouterProvider router={router} /></QueryClientProvider>
    </StrictMode>
  );
}).catch(() => {
  reactRoot.render(
    <StrictMode>
      <main role="alert">
        <h1>Course content could not be loaded</h1>
        <p>The course is temporarily unavailable. Please try again later.</p>
      </main>
    </StrictMode>
  );
});
